import { padding, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  ${padding(4)};
  border-top: solid ${themeGet('colors.gray.100')} ${pxToRem(1)};
`;
